module.exports = __webpack_public_path__ + "static/media/img2.ab18ff35.jpg";